<template>
  <div class="passenger-container">
    <div class="flight-head">
      航班号 {{ passengerData.flightNo }}
    </div>
    <div class="flight-info">
      <div class="item flex-hl-vc">
        <l8-icon class="icon l8-icon" type="icon-checkin-departure" />
        <p class="city">{{ passengerData.depAirportName }}</p>
      </div>
      <div class="item flex-hl-vc">
        <l8-icon class="icon l8-icon" type="icon-checkin-time" />
        <p class="time">{{ passengerData.depDateFormat + ' ' + passengerData.depTimeFormat }}</p>
      </div>
      <div class="item flex-hl-vc">
        <l8-icon class="icon l8-icon" type="icon-checkin-arrival" />
        <p class="city">{{ passengerData.arrAirportName }}</p>
      </div>
    </div>
    <!-- <div class="passenger-info" :class="{ active: passengerIndex === 0 }" @click="selectPassenger(0)">
      <div class="item flex-hl-vc">
        <span class="index">1</span>
        <p>姓名：{{ passengerData.passengerChnName }}</p>
      </div>
       <div class="item flex-hl-vc">
        <l8-icon class="icon l8-icon" type="icon-itinerary-services" />
        <p>座位号：{{flightStatus === 'checked' ? stepData.seatNumber : '-' }}</p>
      </div>
    </div> -->
    <template v-for="(item, index) in mutiPassengerData">
      <div class="passenger-info" :key="item.ticketID" :class="{ active: passengerIndex === index }"
        @click="selectPassenger(index)">
        <div class="flex-hb-vc">
          <div>
            <div class="item flex-hl-vc">
              <span class="index">{{ index + 1 }}</span>
              <p>姓名：{{ item.passengerName ?? item.passengerChnName }}</p>
            </div>
            <div class="item flex-hl-vc">
              <l8-icon class="icon l8-icon" type="icon-itinerary-services" />
              <p>座位号：{{ item.seatNumber || '-' }}</p>
            </div>
          </div>
          <div class="reduce-passenger" v-if="index !== 0" @click="handleRemovePartner(item)">
            <l8-icon class="icon l8-icon" type="icon-checkin-reduce" />
          </div>
        </div>
      </div>
    </template>
    <div class="passenger-action add-passenger" @click="showPartnerModal">
      <l8-icon class="icon l8-icon" type="icon-add" /> 添加同行人
    </div>
    <a-modal v-model="addVisible" title="添加同行人" wrapClassName="add-modal" :footer="null">
      <checkin-form ref="checkin-form" @callback="handleAddPartner" :passengerData="passengerData"
        :isSubmitLoading="isSubmitLoading" type="add"></checkin-form>
    </a-modal>
  </div>
</template>
<script>
import CheckinForm from '@/components/checkin/checkinForm'
import { handlePartner } from '@/apis/checkin'
export default {
  components: {
    CheckinForm
  },
  props: {
    passengerData: { type: Object },
    mutiPassengerData: { type: Array },
    passengerLoading: { type: Boolean },
    flightStatus: { type: String }
  },
  data () {
    return {
      addVisible: false,
      idInfo: {},
      passengerIndex: 0,
      addPassengerData: [],
      isSubmitLoading: false,
      partnerNumberLimit: 5 // 主+同行人旅客数量限制
    }
  },
  created () {
    this.finalSubmit()
  },
  methods: {
    showPartnerModal () {
      const { mutiPassengerData = [], partnerNumberLimit } = this
      if (mutiPassengerData.length >= partnerNumberLimit) {
        this.$message.warn(`最多可添加${partnerNumberLimit - 1}个同行人`)
        return
      }
      this.addVisible = true
      // 重置表单状态
      this.$nextTick(() => {
        this.$refs['checkin-form']?.form.resetFields()
        this.$refs['checkin-form']?.$refs['verify'].refresh()
      })
    },
    selectPassenger (index = 0) {
      this.passengerIndex = index
      this.$emit('select', index)
    },
    handleAddPartner (data) {
      this.isSubmitLoading = true
      const addPartner = []
      addPartner.push(data)
      this.finalSubmit(addPartner, [])
    },
    handleRemovePartner (data) {
      const { passengerName, idNo: certNo, ticketNo, flightDate } = data
      const subPartner = []
      subPartner.push({
        passengerName,
        certNo,
        ticketNo,
        flightDate
      })
      this.finalSubmit([], subPartner)
    },
    async finalSubmit (addPartner = [], subPartner = []) {
      const { passengerData = {} } = this
      const {
        certTypeOrigin: certType,
        ticketNo, passengerName,
        passengerType,
        flightNo,
        depTime: flightDate,
        depCode,
        arrCode,
        cabin,
        phone,
        hostNumber,
        tourIndex
      } = passengerData
      const params = {
        addPartner,
        subPartner,
        certType,
        ticketNo,
        passengerName,
        passengerType,
        flightNo,
        flightDate,
        depCode,
        arrCode,
        cabin,
        phone,
        hostNumber,
        tourIndex
      }
      try {
        const result = await handlePartner({
          ...params,
          slideCaptcha: new Date().getTime()
        })
        if (addPartner.length > 0) {
          this.addVisible = false
          this.isSubmitLoading = false
          this.$message.success('添加同行人成功')
        } else if (subPartner.length > 0) {
          this.$message.success('删除同行人成功')
        }
        const { psrInput = {}, partners = [] } = result
        const data = []
        data.push({
          passengerName: psrInput.passengerName,
          ticketID: psrInput.tktNumber
        })
        for (let index = 0; index < partners.length; index++) {
          data.push({
            passengerName: partners[index].passengerName,
            ticketID: partners[index].ticketID
          })
        }
        this.$emit('update', data, result)
        this.selectPassenger()
      } catch (error) {
        this.isSubmitLoading = false
        this.$message.error(error.message)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.passenger-container {
  border: 1px solid #febdc2;
  border-radius: 8px;
  color: #333;
  font-size: 14px;

  .flight-head {
    background-color: @primary-color;
    color: #fff;
    padding: 10px;
    text-align: center;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  .flight-info,
  .passenger-info,
  .passenger-action {
    padding: 10px;

    .item {
      line-height: 2;

      .icon {
        padding-right: 10px;
      }

      .index {
        border-radius: 50%;
        background-color: #555;
        color: #fff;
        width: 16px;
        height: 16px;
        line-height: 16px;
        text-align: center;
        display: inline-block;
        font-size: 12px;
        margin-right: 12px;
        margin-left: 2px;
        flex: 1 0 auto;
      }
    }
  }

  .flight-info,
  .passenger-info {
    border-bottom: 1px solid #febdc2;
  }

  .passenger-info,
  .passenger-action {
    &:hover {
      transition: 0.5s ease-in-out;
      background: #ffebed;
      opacity: .7;
    }
  }

  .passenger-info {
    cursor: pointer;

    &.active {
      background: #ffebed;
    }
  }

  .passenger-action {
    color: @primary-color;
    text-align: center;
    font-weight: bolder;
    cursor: pointer;

    .icon {
      font-size: 14px;
    }
  }
}
</style>
